/**
* GENERATED BY KRPC GEN - LESS MODIFY BY HAND
* user-service.ts  2025-08-12T13:43:44+08:00
*/
import type { R, RpcService, MethodConfig as M } from 'krpc-base';

import type { UserInfo, VipInfo, MyGrowth, StatInfo, UserBasic } from './wy-dto';

const _ = 'User/';

export class UserService {

  constructor(readonly r: RpcService) {}
  // 当前账户基础信息/昵称/头像
  basic(m?: M): R<UserBasic>{
    return this.r.async(_ + 'basic', undefined, m);
  }
  // 获取当前用户的成长等级
  growth(m?: M): R<MyGrowth>{
    return this.r.async(_ + 'growth', undefined, m);
  }
  // 当前账户全部信息/手机号/生日/微信等
  info(m?: M): R<UserInfo>{
    return this.r.async(_ + 'info', undefined, m);
  }
  // 获取当前用户的统计信息，techType=2关注数只查询往约技师相关，8只查询汗滴技师相关，为空或者0不做区分查询当前用户所有关注数
  stat(d:number, m?: M): R<StatInfo>{
    return this.r.async(_ + 'stat', d, m);
  }
  // 获取当前用户的会员卡信息
  vip(m?: M): R<VipInfo>{
    return this.r.async(_ + 'vip', undefined, m);
  }
}
